if (!customElements.get('quantum-card-gallery')) {
  customElements.define('quantum-card-gallery', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.imageObserver?.disconnect();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const track = this.querySelector('.qcg__track');
      if (!track) return;
      const slides = [...track.querySelectorAll('.qcg__slide')];
      const controls = this.querySelector('.qcg__controls');
      const dots = [...this.querySelectorAll('[data-slide]')];
      const arrows = [...this.querySelectorAll('[data-step]')];
      let index = 0, frame = 0, gesture = null, suppressUntil = 0;
      const direction = () => getComputedStyle(track).direction === 'rtl' ? -1 : 1;
      const sync = () => {
        frame = 0;
        index = Math.max(0, Math.min(slides.length - 1, Math.round(Math.abs(track.scrollLeft) / (track.clientWidth || 1))));
        dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
        slides.forEach((slide, i) => slide.tabIndex = i === index ? 0 : -1);
        arrows.forEach(button => button.disabled = Number(button.dataset.step) < 0 ? index === 0 : index === slides.length - 1);
      };
      const go = i => track.scrollTo({ left: direction() * Math.max(0, Math.min(slides.length - 1, i)) * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      track.addEventListener('pointerdown', event => {
        if (!event.isPrimary || event.button !== 0) return;
        suppressUntil = 0;
        gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, scroll: track.scrollLeft, moved: false, mouse: event.pointerType === 'mouse', drag: false };
      }, { ...options, passive: true });
      document.addEventListener('pointermove', event => {
        if (!gesture || gesture.id !== event.pointerId) return;
        const dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
        if (Math.hypot(dx, dy) > 10 || Math.abs(track.scrollLeft - gesture.scroll) > 8) gesture.moved = true;
        if (gesture.mouse && slides.length > 1 && (gesture.drag || Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy))) {
          if (!gesture.drag) { gesture.drag = true; this.setAttribute('data-dragging', ''); track.setPointerCapture(event.pointerId); }
          track.scrollLeft = gesture.scroll - dx;
          event.preventDefault();
        }
      }, options);
      const endGesture = event => {
        if (!gesture || gesture.id !== event.pointerId) return;
        if (Math.hypot(event.clientX - gesture.x, event.clientY - gesture.y) > 10 || Math.abs(track.scrollLeft - gesture.scroll) > 8) gesture.moved = true;
        if (gesture.moved || event.type === 'pointercancel') suppressUntil = performance.now() + 800;
        const wasDrag = gesture.drag;
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
        this.removeAttribute('data-dragging');
        gesture = null;
        if (wasDrag) go(Math.round(Math.abs(track.scrollLeft) / (track.clientWidth || 1)));
      };
      document.addEventListener('pointerup', endGesture, { ...options, passive: true });
      document.addEventListener('pointercancel', endGesture, { ...options, passive: true });
      track.addEventListener('click', event => {
        if (event.detail === 0 || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (performance.now() < suppressUntil) { event.preventDefault(); event.stopPropagation(); suppressUntil = 0; }
      }, { ...options, capture: true });
      track.addEventListener('dragstart', event => event.preventDefault(), options);
      track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault(); event.stopPropagation();
        go(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : index + (event.key === 'ArrowRight' ? direction() : -direction()));
      }, options);
      controls?.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        event.preventDefault(); event.stopPropagation();
        go(button.hasAttribute('data-slide') ? Number(button.dataset.slide) : index + Number(button.dataset.step));
      }, options);
      track.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(sync); }, { ...options, passive: true });
      this.controller.signal.addEventListener('abort', () => cancelAnimationFrame(frame), { once: true });
      this.observer = new ResizeObserver(sync); this.observer.observe(track);
      const swatchImage = slides[0]?.querySelector('.card__img');
      if (swatchImage) {
        this.imageObserver = new MutationObserver(() => go(0));
        this.imageObserver.observe(swatchImage, { attributes: true, attributeFilter: ['src', 'srcset'] });
      }
      if (controls) controls.hidden = false;
      sync();
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); this.imageObserver?.disconnect(); }
  });
}
